const setSelectedFolderIdAction = ({ commit }, payload) => {
  commit('setSelectedFolderId', payload)
}

const setSelectedTabAction = ({ commit }, payload) => {
  commit('setSelectedTab', payload)
}

const setSelectedSlideIdsAction = ({ commit }, payload) => {
  commit('setSelectedSlideIds', payload)
}

const setSelectedSortCriteriaAction = ({ commit, dispatch }, payload) => {
  commit('setSelectedSortCriteria', payload)
  if (payload) {
    dispatch('updateUserRememberSettingAction', {
      sortColumn: payload.sortColumn,
      sortOrder: payload.sortOrder,
    })
  }
}

export default {
  setSelectedTabAction,
  setSelectedFolderIdAction,
  setSelectedSlideIdsAction,
  setSelectedSortCriteriaAction,
}
